import React, { useContext, useRef, useMemo, useCallback, useEffect } from 'react'
import { Link } from 'react-router-dom'
import t from '~t'
import { eventOrder } from '~modules/browser'
import { Context } from '../'

import { Button, Header, Icon } from '~ui'

export default function SplitViewReaderHeader({
    'data-no-shadow': noShadow = true,
    backTo = '',
    onBackClick,
    onFullscreenClick,
    children
}) {
    const context = useContext(Context)
    const backButton = useRef(null)
    const eventToken = useMemo(() => ({}), [])

    useEffect(() => {
        eventOrder.add(eventToken)
        return () => eventOrder.delete(eventToken)
    }, [eventToken])

    useEffect(() => {
        const onWindowKeyDown = e => {
            switch (e.key) {
                case 'Escape':
                    if (!eventOrder.isLast(eventToken))
                        return

                    e.preventDefault()
                    e.stopPropagation()
                    backButton.current.click()
                    break
            }
        }

        window.addEventListener('keydown', onWindowKeyDown)
        return () => window.removeEventListener('keydown', onWindowKeyDown)
    }, [eventToken])

    const onBackClickHandler = useCallback(
        e => {
            if (!e.currentTarget.href) {
                e.preventDefault()
                onBackClick && onBackClick()
            }
        },
        [onBackClick]
    )

    const onFullscreenClickHandler = useCallback(
        e => {
            e.preventDefault()
            onFullscreenClick && onFullscreenClick()
        },
        [onFullscreenClick]
    )

    const fullscreen = context.reader.fullscreen

    return (
        <Header
            data-no-shadow={noShadow}
            data-fancy
            data-window-inset
            className='svReaderHeader'>
            <Button
                variant='ghost'
                ref={backButton}
                as={Link}
                to={backTo}
                onClick={onBackClickHandler}>
                <Icon name='close' />
            </Button>

            <Button
                href=''
                onClick={onFullscreenClickHandler}
                variant={fullscreen ? 'accent' : 'ghost'}
                className='svReaderFullscreenButton'
                title={t.s('fullscreen')}>
                <Icon name={'fullscreen' + (fullscreen ? '_active' : '')} />
            </Button>

            {children}
        </Header>
    )
}
